export default __webpack_public_path__ + "static/media/enterprise.f389c8c8.jpg";